import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Css/View.css";
import API_BASE from "../config/api";

const TeacherView = () => {
  const navigate = useNavigate();
  const { teacherUserId } = useParams();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeacher();
  }, []);

  const fetchTeacher = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/institute/teachers/${teacherUserId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setTeacher(res.data);
    } catch (err) {
      console.error("Failed to load teacher", err);
    } finally {
      setLoading(false);
    }
  };
  console.log("Teacher data:", teacher);


  const handleEditClick = () => {
    navigate(`/dashboard/teacheredit/${teacherUserId}`);
  };

  if (loading) return <p>Loading...</p>;
  if (!teacher) return <p>No data found</p>;

  return (
    <div className="student-page">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          शिक्षक व्यवस्थापन &gt;&gt; <span>शिक्षक तपशील</span>
        </h3>
        <button className="edit-btn" onClick={handleEditClick}>
          एडिट करा
        </button>
      </div>

      <h2>शिक्षक प्रोफाइल</h2>

      <div className="profile-card">
        {teacher.profilePictureUrl && (
          <img
            src={`${API_BASE}${teacher.profilePictureUrl}`}
            alt="teacher"
            className="profile-img"
          />
        )}
      </div>
      <div className="info-grid">
        <div className="info-box">
          <label>शिक्षकाचे नाव</label>
          <p>{teacher.teacherName}</p>
        </div>

        <div className="info-box">
          <label>ईमेल</label>
          <p>{teacher.email}</p>
        </div>

        <div className="info-box">
          <label>मोबाईल नं.</label>
          <p>{teacher.phoneNumber || "-"}</p>
        </div>

        <div className="info-box">
          <label>नियुक्त इयत्ता</label>
          <p>
            {teacher.standardIds.length > 0
              ? teacher.standardIds.join(", ")
              : "-"}
          </p>
        </div>

        <div className="info-box">
          <label>नियुक्त परीक्षेचे नाव</label>
          <p>
            {teacher.softwareIds.length > 0
              ? teacher.softwareIds.join(", ")
              : "-"}
          </p>
        </div>

        <div className="info-box">
          <label>नियुक्त विषय</label>
          <p>
            {teacher.subjectIds.length > 0
              ? teacher.subjectIds.join(", ")
              : "-"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeacherView;
